import * as React from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import CircularProgressbar from "../common/CircularProgressbar";
import { logUI } from '../../api/andyliticsApi';
import * as Tools from "../../helpers/Tools";


const WellBeingScoreTile = props => {
    const { report, currentYear } = props;
    const previousYear = currentYear - 1;
    let results = [];
    const defaultScoreColor = "#008fbe";
    // Get Current year data to show current year score
    let currentYearReport = report && report.length > 0 && report.filter(item => item.year === currentYear)[0];
    // Get Previous Year data    
    let previousYearReport = report && report.length > 0 && report.filter(item => item.year === previousYear)[0];
    const { overallScoreInterpretation = null, overallScore = 0, overallScoreColor = defaultScoreColor } = currentYearReport || {};
    if ((currentYearReport && currentYearReport.results) || (previousYearReport && previousYearReport.results))
        results = ((currentYearReport && currentYearReport.results) || (previousYearReport && previousYearReport.results)).map((result, index) => {
            const previousYearResult = currentYearReport && currentYearReport.results ? previousYearReport && previousYearReport.results &&
                previousYearReport.results.find(goal => goal.name == result.name) : result;
            return (
                <div className={`col-lg-4 col py-2 col-sm-6 ${(result.name === 'Overall') ? ' hidden' : ''}`} key={"results_" + index}>
                    <div className="row">
                        <div className="col-12">{result.name}</div>
                    </div>
                    <div className="row">
                        <div className="col-12 individual-score__container">
                            <div className="individual-current-year">
                                <CircularProgressbar percentage={currentYearReport && currentYearReport.results ? result.score : 0} overallScoreColor={defaultScoreColor} rotation={0.00}/>
                            </div>
                            {(previousYearReport && previousYearReport.results && previousYearResult) &&
                                <div className="score-tile__previous-year">
                                <CircularProgressbar percentage={previousYearResult.score} overallScoreColor={defaultScoreColor} rotation={0.00}/>
                                    <div className="year">{previousYear}</div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            )
        })

    return (
        <div className="score-tile card">
            <div className="card-header">
                <div className="row">
                    <div className="col-12 score-tile__header"><span className="svg-post-it" /><div className="card-heading">WELL-BEING SCORE</div>
                    </div>
                </div>
            </div>
            <div className="row m-0 mr-3">
                <div className="col-12 col-sm-6 col-md-8 p-0">
                    <div className="row card-body">
                        <div className="col-12">
                            <span>{overallScoreInterpretation}</span>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-6 col-md-4 score-tile__container">
                    <div className="score-tile__overall-current-year">
                        <CircularProgressbar percentage={overallScore} overallScoreColor={defaultScoreColor} showText="Overall" rotation={0.00}/>
                    </div>
                    {previousYearReport &&
                        <div className="score-tile__previous-year">
                        <CircularProgressbar percentage={previousYearReport.overallScore || 0} overallScoreColor={defaultScoreColor} rotation={0.00}/>
                            <div className="year">{previousYear}</div>
                        </div>
                    }
                </div>
            </div>
            {results && results.length > 0 &&
                <div className="row list-row score-tile__individual card-body">
                    <div className="col-12">
                        <h3 className="score">Individual Scores</h3>
                    </div>
                    <div className="col-12">
                        <div className="row individual-score">
                            {results}
                        </div>
                    </div>
                </div>
            }
            <div className="card-footer row">
                <div className="col-12 text-right">
                    <Link className="card-link" to={{ pathname: '/wellbeingreport'}} onClick={() => logUI("MBHWeb.UI.WellBeingDashboard.WellBeingScoreTile.ViewFullReportClicked", new Date(), Tools.getURLPath())}>VIEW FULL REPORT </Link>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        report: state.thrive.report,
    }
}

export default withRouter(connect(mapStateToProps)(WellBeingScoreTile));

